import * as actionTypes from './actiontypes';
import * as API from './api';
import { log, showMessage } from '../../config/utils';
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes';

export const updateMemberState = (payload, path) => {
  return {
    type: actionTypes.UPDATE_AGENT_STATE,
    payload,
    path
  };
};

export const getAllAgents = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.AGENTS_LOADING,
    });
    API.getAllAgents({}, (error, response) => {
      log('get all agents response:', response);
      if (!error && response && response.data) {
        dispatch({
          type: actionTypes.AGENTS_LOADED,
          payload: response.data,
        });
      } else {
        dispatch({
          type: actionTypes.AGENTS_LOAD_ERROR,
        });
      }
    });
  };
};

export const inviteNewAgents = (data, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.NEW_AGENTS_ADDING,
    });
    API.inviteNewAgents(data, (error, response) => {
      log('add new agents response:', response);
      if (!error && response && response.data) {
        dispatch({
          type: actionTypes.NEW_AGENTS_ADDED,
          payload: response.data,
        });
        if (callback) callback();
        showMessage('success', response.message ? response.message : 'agents successfully added.');
      } else {
        dispatch({
          type: actionTypes.NEW_AGENTS_ADDITION_ERROR,
        });
      }
    });
  };
};

export const getAgentProfileDetails = (data, callback) => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "profile details loading"
    });
    API.getAgentProfileDetails(data, (error, response) => {
      log('get agents  profile response:', response);
      dispatch({
        type: PAGE_LOADED,
      });
      if (!error && response && response.data && response.data.agentList) {
        callback(false, response.data.agentList);
      } else {
        callback(true);
      }
    });
  };
};

export const updateAgent = (data, callback) => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "agent updating"
    });
    API.updateAgent(data, (error, response) => {
      log('update agent response:', response);
      dispatch({
        type: PAGE_LOADED,
      });
      if (!error && response && response.data) {
        callback();
        showMessage('success', `${data.email} has been successfully updated.`);
      }
    });
  };
};


export const deleteAgent = data => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "deleting"
    });
    API.deleteAgent(data, (error, response) => {
      log('delete agent response:', response);
      dispatch({
        type: PAGE_LOADED,
      });
      if (!error && response && response.data) {
        dispatch({
          type: actionTypes.AGENT_DELETED,
          payload: response.data,
        });
        showMessage('success', `${data.email} has been successfully deleted.`);
      }
    });
  };
};

export const getAllGroups = callback => {
  return dispatch => {
    dispatch({
      type: actionTypes.GROUPS_LOADING,
    });
    API.getAllGroups({}, (error, response) => {
      log('get all groups response:', response);
      if (callback) {
        callback();
      }
      if (!error && response && response.data) {
        dispatch({
          type: actionTypes.GROUPS_LOADED,
          payload: response.data,
        });
      } else {
        dispatch({
          type: actionTypes.GROUPS_LOAD_ERROR,
        });
      }
    });
  };
};

export const getGroupDetails = (data, callback) => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "group details creating"
    });
    API.getGroupDetails(data, (error, response) => {
      log('get  group details response:', response);
      dispatch({
        type: PAGE_LOADED,
      });
      if (!error && response && response.data && response.data.agentGroup) {
        callback(false, response.data.agentGroup);
      } else {
        callback(true);
      }
    });
  };
};

export const createGroup = (data, callback) => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "group creating"
    });
    API.createGroup(data, (error, response) => {
      log('create group response:', response);
      dispatch({
        type: PAGE_LOADED,
      });
      if (!error && response) {
        callback();
        showMessage('success', `group (${data.name}) has been successfully created.`);
      }
    });
  };
};

export const updateGroup = (data, callback) => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "group updating"
    });
    API.updateGroup(data, (error, response) => {
      log('update group response:', response);
      dispatch({
        type: PAGE_LOADED,
      });
      if (!error && response) {
        callback();
        showMessage('success', `group (${data.name}) has been successfully updated.`);
      }
    });
  };
};

export const deleteGroup = (data, callback) => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "group deleting"
    });
    API.deleteGroup(data, (error, response) => {
      log('delete group response:', response);
      dispatch({
        type: PAGE_LOADED,
      });
      if (!error && response && response.data) {
        dispatch({
          type: actionTypes.GROUP_DELETED,
          payload: response.data
        });
        if (callback) callback();
        showMessage('success', `group (${data.name}) has been successfully deleted.`);
      }
    });
  };
};

export const getAgentCannedResponses = data => {
  return dispatch => {
    dispatch({
      type: actionTypes.CANNED_RESPONSES_LOADING,
    });
    API.getAgentCannedResponses(data, (error, response) => {
      log('get agent canned response:', response);
      if (!error && response && response.data) {
        dispatch({
          type: actionTypes.CANNED_RESPONSES_LOADED,
          payload: response.data,
        });
      } else {
        dispatch({
          type: actionTypes.CANNED_RESPONSES_LOAD_ERROR,
        });
      }
    });
  };
};

export const createCannedResponse = (data, callback) => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "canned response creating"
    });
    API.createCannedResponse(data, (error, response) => {
      log('create canned response:', response);
      dispatch({
        type: PAGE_LOADED,
      });
      if (!error && response && response.data) {
        dispatch({
          type: actionTypes.CANNED_RESPONSE_CREATED,
          payload: response.data
        });
        if (callback) callback();
        showMessage('success', response && response.message ? response.message : 'canned response successfully created.');
      }
    });
  };
};

export const updateCannedResponse = (data, callback) => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "canned response deleting"
    });
    API.updateCannedResponse(data, (error, response) => {
      log('update canned response:', response);
      dispatch({
        type: PAGE_LOADED,
      });
      if (!error && response && response.data) {
        dispatch({
          type: actionTypes.CANNED_RESPONSE_UPDATED,
          payload: response.data
        });
        if (callback) callback();
        showMessage('success', response && response.message ? response.message : 'canned response successfully updated.');
      }
    });
  };
};

export const deleteCannedResponse = data => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "canned response deleting"
    });
    API.deleteCannedResponse(data, (error, response) => {
      log('delete canned response:', response);
      dispatch({
        type: PAGE_LOADED,
      });
      if (!error && response && response.data) {
        dispatch({
          type: actionTypes.CANNED_RESPONSE_DELETED,
          payload: response.data
        });
        showMessage('success', response && response.message ? response.message : 'canned response successfully deleted.');
      }
    });
  };
};

// ----------------------------------- SOCKET ACTIONS ----------------------------------------

export const makeMemberPageSocketConnection = host => {
  return {
    type: actionTypes.MAKE_MEMBER_PAGE_SOCKET_CONNECTION,
    host
  };
};

export const memberSocketDisconnect = () => {
  return {
    type: actionTypes.MEMBER_SOCKET_DISCONNECT,
  };
};

export const emitMemberCustomEvent = (event, payload, callback) => {
  return {
    type: actionTypes.EMIT_MEMBER_CUSTOM_EVENT,
    event,
    payload,
    callback
  };
}

export const updateTransferChatData = payload => {
  return {
    type: actionTypes.UPDATE_TRANSFER_CHAT_DATA,
    payload,
  };
};

export const loadAgentListForSelectedGroup = payload => {
  return {
    type: actionTypes.LOAD_AGENT_LIST_FOR_SELECTED_GROUP,
    payload,
  };
};

// ----------------------------------- TAGS ----------------------------------------

export const getAllTags = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.TAGS_LOADING,
    });
    API.getAllTags({}, (error, response) => {
      log('get all tags response:', response);
      if (!error && response && response.data) {
        dispatch({
          type: actionTypes.TAGS_LOADED,
          payload: response.data,
        });
      } else {
        dispatch({
          type: actionTypes.TAGS_LOAD_ERROR,
        });
      }
    });
  };
};

export const createTag = (data, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.UPDATE_AGENT_STATE,
      payload: true,
      path: 'loaders.tag_updating'
    });
    API.createTag(data, (error, response) => {
      log('create new Tag response:', response);
      if (!error && response && response.data && response.data.createdTag) {
        dispatch({
          type: actionTypes.TAG_CREATED,
          payload: response.data.createdTag,
        });
        callback();
        showMessage('success', response.message ? response.message : 'Tag has been successfully created!');
      }
      dispatch({
        type: actionTypes.UPDATE_AGENT_STATE,
        payload: false,
        path: 'loaders.tag_updating'
      });
    });
  };
};

export const updateTag = (data, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.UPDATE_AGENT_STATE,
      payload: true,
      path: 'loaders.tag_updating'
    });
    API.updateTag(data, (error, response) => {
      log('update Tag response:', response);
      if (!error && response && response.data && response.data.updatedTag && response.data.updatedTag._id) {
        dispatch({
          type: actionTypes.TAG_UPDATED,
          payload: response.data.updatedTag,
        });
        callback();
        showMessage('success', response.message ? response.message : 'Tag has been successfully updated');
      }
      dispatch({
        type: actionTypes.UPDATE_AGENT_STATE,
        payload: false,
        path: 'loaders.tag_updating'
      });
    });
  };
};

export const deleteTag = data => {
  return dispatch => {
    dispatch({
      type: PAGE_LOADING,
      payload: "Tag deleting"
    });
    API.deleteTag(data, (error, response) => {
      log('delete tag response:', response);
      dispatch({
        type: PAGE_LOADED,
      });
      if (!error && response && response.data && response.data.deletedTag) {
        dispatch({
          type: actionTypes.TAG_DELETED,
          payload: response.data.deletedTag
        });
        showMessage('success', `Tag has been successfully deleted!`);
      }
    });
  };
};
export const resetPassWord = (data, callback) => {
    return dispatch => {
        dispatch({
            type: PAGE_LOADING,
        });
        API.resetPassWord(data, (error, response) => {
            log('Reset password response:', response);
            if (!error && response && response.data) {
                dispatch({
                    type: PAGE_LOADED,
                    payload: response.data,
                });
                if (callback) callback();
                showMessage('success', response.message ? response.message : 'agents successfully added.');
            } 
        });
    };
};


// WEBPACK FOOTER //
// ./src/data/redux/member_details/actions.js